import axios from 'axios';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? window.location.hostname === '192.168.1.7'
        ? 'http://192.168.1.7:8080'
        : `${process.env.REACT_APP_DEV_API_URL}`
      : `${process.env.REACT_APP_PROD_API_URL}`,
});

export default instance;
